<template>
    <div class="content-con clearfix">
      <div class="left-area" :style="{ width: leftWidth}">
        <slot></slot>
      </div>
      <div class="right-area" :style="{width: rightWidth}">
        <el-image style="margin-top: 6.4px"
            :src="url"
            fit="cover"></el-image>
      </div>
    </div>
</template>

<script>
export default {
  name: "infor-card",
  props: {
    left: {
      type: Number,
      default: 60
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    url: {
      type: String,
      default: ''
    }
  },
  computed: {
    leftWidth() {
      return `${this.left}%`
    },
    rightWidth() {
      return `${100 - this.left}%`
    },
    styles() {
      return {
        fontSize: `${this.iconSize}px`,
        color: this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>

  .content-con {
    width: 100%;
    height: 100%;
    position: relative;

    .left-area {
      float: left;
      height: 100%;
      display: table;
      text-align: left;
    }

    .right-area {
      float: left;
      height: 76.8px;
      display: table;
      text-align: center;
    }
  }

  .clearfix:after { /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
</style>
